import { render } from "./ReEnrollmentPrompt.vue?vue&type=template&id=319288d2"
import script from "./ReEnrollmentPrompt.vue?vue&type=script&lang=js"
export * from "./ReEnrollmentPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__